import React from 'react'

import './List.css'

type ListProps<T> = {
  items: T[]
  emptyLabel: string
  children?: (item: T) => React.ReactElement
}

export function List<T extends object>({ children, emptyLabel, items }: ListProps<T>) {
  if (!children) {
    return children
  }

  return (
    <div className="List">
      {items.length > 0 ? (
        items.map((item) => children(item))
      ) : (
        <div className="List-emptyText">{emptyLabel}</div>
      )}
    </div>
  )
}

type ListItemProps = {
  children: React.ReactNode
}

export function ListItem({ children }: ListItemProps) {
  return <div className="List-item">{children}</div>
}
